import { cn } from "@githits/shared";
import { LanguageIcon } from "@githits/replay-shared";

interface ExampleCardProps {
  language: string;
  languageLabel: string;
  query: string;
  isViewed: boolean;
  onCta: () => void;
}

export default function ExampleCard({
  language,
  languageLabel,
  query,
  isViewed,
  onCta,
}: ExampleCardProps) {
  const ctaLabel = isViewed ? "Watch Again" : "Watch Replay";
  return (
    <div
      onClick={onCta}
      className={cn(
        "ghw-group ghw-flex ghw-flex-col ghw-h-full ghw-box-border ghw-cursor-pointer",
        "ghw-bg-[rgba(33,38,45,0.65)] hover:ghw-bg-[#21262D] ghw-rounded-lg",
        "ghw-transition-all ghw-duration-300 ghw-ease-out",
        "md:hover:ghw-scale-110",
        "ghw-py-7 ghw-px-6"
      )}
    >
      <div className="ghw-flex ghw-flex-1 ghw-flex-col ghw-gap-3">
        <LanguageIcon language={language} label={languageLabel} isActive={false} />
        <p className="ghw-m-0 ghw-text-sm ghw-leading-5 ghw-text-muted-foreground ghw-font-inter">
          {query}
        </p>
      </div>
      {/* No onClick handler here: the click (from a mouse click, or from
          keyboard Enter/Space on the focused button) bubbles to the wrapper
          div which owns the single onCta handler. Avoids a double-fire bug
          where both the button and the card would run onCta on one click. */}
      <button
        type="button"
        className={cn(
          "ghw-mt-6 ghw-w-full ghw-flex ghw-items-center ghw-justify-center ghw-gap-2",
          "ghw-px-3 ghw-py-2 ghw-rounded-full ghw-text-sm ghw-font-medium",
          "ghw-bg-transparent ghw-cursor-pointer",
          "ghw-border ghw-border-solid ghw-border-white group-hover:ghw-border-[#FF4FAE]",
          "ghw-text-white group-hover:ghw-text-[#FF4FAE] ghw-transition-colors",
          "focus-visible:ghw-outline-none focus-visible:ghw-ring-2 focus-visible:ghw-ring-primary/40"
        )}
      >
        {ctaLabel}
        <svg
          width="14"
          height="14"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M5 12h14" />
          <path d="m12 5 7 7-7 7" />
        </svg>
      </button>
    </div>
  );
}
